import React from 'react';
import { trackEvent } from '../../utils/analytics';
import { G2_RATING, G2_URL } from '../../content/g2Rating';
import './G2RatingPill.css';

/**
 * G2RatingPill — our G2 rating as TEXT (Nitish, Sep 27 2026; canon g2-claims).
 *
 * Rules that must hold:
 *  - links to our G2 profile and carries "Source: G2.com, Inc." (G2 guideline);
 *  - NO G2 logo or badge until legal@g2.com grants written permission
 *    (requested Sep 27 2026); stars are amber, never G2 red;
 *  - the rating lives in src/content/g2Rating.json only, never in JSON-LD.
 *
 * Sits in the fold's left column, level with the DeepResearch pill on the right.
 */
/* `children` (Oct 20 2026): a sibling pill rendered right after the G2 pill and before the
   source line (HomeFold puts the NYT pill here, CEL-3460). */
const G2RatingPill = ({ page, location = 'hero', children = null }) => (
  <div className="mkt-g2">
    <a
      className="mkt-g2__pill"
      href={G2_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Rated ${G2_RATING} out of 5 on G2`}
      onClick={
        page
          ? () => trackEvent('cta_click', { cta_name: 'g2_rating', page, compare_page: page, location })
          : undefined
      }
    >
      <span className="mkt-g2__stars" aria-hidden="true">★★★★★</span>
      <span className="mkt-g2__rating" aria-hidden="true">{G2_RATING}</span>
      <span className="mkt-g2__on" aria-hidden="true">on G2</span>
    </a>
    {children}
    <span className="mkt-g2__source">Source: G2.com, Inc.</span>
  </div>
);

export default G2RatingPill;
